import React from "react";
import { IconTrendDown, IconTrendUp } from "./ui/icons";

function formatPct(value) {
  const abs = Math.abs(value);
  const digits = abs >= 1000 ? 0 : 1;
  return abs.toLocaleString("sr-RS", { minimumFractionDigits: digits, maximumFractionDigits: digits });
}

/**
 * Percent change badge: green/red with an arrow, neutral grey 0% when there is nothing to compare.
 * invert: for metrics where growth means worse (e.g. expense).
 */
export default function ChangeBadge({ changePct, invert = false }) {
  const hasChange = changePct !== null && changePct !== undefined && Number.isFinite(changePct);
  const pct = hasChange ? changePct : 0;
  const isNeutral = pct === 0 || Math.abs(pct) < 0.05;
  const isIncrease = pct >= 0;
  const isGood = invert ? !isIncrease : isIncrease;
  return (
    <span
      className={`inline-flex items-center gap-0.5 rounded px-1 py-0.5 text-xs font-medium tabular-nums ${
        isNeutral
          ? "bg-slate-200/60 text-slate-600 dark:bg-slate-700/50 dark:text-slate-300"
          : isGood
            ? "bg-success/10 text-success-dark dark:text-success-light"
            : "bg-danger/10 text-danger-dark dark:text-danger-light"
      }`}
    >
      {isNeutral ? null : isIncrease ? <IconTrendUp aria-hidden="true" /> : <IconTrendDown aria-hidden="true" />}
      {formatPct(pct)}%
    </span>
  );
}
